import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateAbsenceDto } from "@myapp/contract";
import { rescheduleKeys } from "src/entities/reschedule";
import { appointmentKeys } from "src/entities/appointment/api/appointment.keys";
import { taskKeys } from "src/entities/task/api/task.keys";
import { scheduleKeys } from "src/entities/schedule/api/schedule.keys";
import { absenceApi } from "../service";
import { absenceKeys } from "../absence.keys";

/**
 * A forced absence (`force: true`) flags every appointment and task it displaces, so this write
 * touches caches it never names. Invalidating only the absence list left the Umdisponierung page,
 * its nav badge and the disposition board showing pre-conflict state.
 */
export function useCreateAbsence() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateAbsenceDto) => absenceApi.create(dto).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: absenceKeys.lists() });
      // `all`, not `count()` — the list is what shows the newly flagged blocks.
      queryClient.invalidateQueries({ queryKey: rescheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
    },
  });
}
